import MuiStylizedTooltip from './MuiStylizedTooltip';

export default MuiStylizedTooltip;
